<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";

   export default {
      page: {
         title: "Print Settings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Print Settings",
            items: [
               {
                  text: "Clinics",
                  href: "/clinics",
               },
               {
                  text: "Print Settings",
                  active: true,
               },
            ],
            clinic: {},
            token: "",
            errors: {},
            loading: false,
            settingsLoaded: false,
            print_token_type: 1,
            prescription_print_config: {
               document_title: '',
               header_source: 1,
               custom_clinic_name: '',
               custom_clinic_address: '',
               custom_clinic_phone: '',
               clinic_name_local: '',
               show_doctor_qualification: 1,
               show_doctor_reg_no: 1,
               show_doctor_mobile: 1,
               show_patient_age: 1,
               show_patient_sex: 1,
               show_patient_mobile: 1,
               show_patient_address: 1,
               show_patient_id: 2,
               patient_id_label: 'UHID',
               patient_id_source: 1,
               show_logo: 2,
               show_qr: 1,
               qr_source: 1,
               show_token: 1,
               token_source: 1,
               show_barcode: 1,
               barcode_source: 1,
               vitals: [],
               timing: '',
               disclaimer: '',
               footer_link: '',
               logo: '',
               qr_image: '',
               barcode_image: '',
               logo_url: '',
               qr_image_url: '',
               barcode_image_url: '',
            },
            logo_file: null,
            logo_preview: null,
            remove_logo: 0,
            qr_image_file: null,
            qr_image_preview: null,
            remove_qr_image: 0,
            barcode_image_file: null,
            barcode_image_preview: null,
            remove_barcode_image: 0,
         };
      },
      computed: {
         clinicId() {
            return this.$route.params.id;
         },
         currentLogoSrc() {
            if (this.logo_preview) {
               return this.logo_preview;
            }
            return this.resolvePrintImageUrl(
               this.prescription_print_config.logo,
               this.prescription_print_config.logo_url
            );
         },
         currentBarcodeSrc() {
            if (this.barcode_image_preview) {
               return this.barcode_image_preview;
            }
            return this.resolvePrintImageUrl(
               this.prescription_print_config.barcode_image,
               this.prescription_print_config.barcode_image_url
            );
         },
         currentQrSrc() {
            if (this.qr_image_preview) {
               return this.qr_image_preview;
            }
            return this.resolvePrintImageUrl(
               this.prescription_print_config.qr_image,
               this.prescription_print_config.qr_image_url
            );
         },
         hasCurrentLogo() {
            return Boolean(this.currentLogoSrc) && Number(this.remove_logo) !== 1;
         },
         hasCurrentBarcodeImage() {
            return Boolean(this.currentBarcodeSrc) && Number(this.remove_barcode_image) !== 1;
         },
         hasCurrentQrImage() {
            return Boolean(this.currentQrSrc) && Number(this.remove_qr_image) !== 1;
         },
      },
      created() {
         this.fetchClinic();
         this.fetchPrescriptionPrintSettings();
      },
      beforeDestroy() {
         if (this.qr_image_preview) {
            URL.revokeObjectURL(this.qr_image_preview);
         }
         if (this.logo_preview) {
            URL.revokeObjectURL(this.logo_preview);
         }
         if (this.barcode_image_preview) {
            URL.revokeObjectURL(this.barcode_image_preview);
         }
      },
      methods: {
         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin = JSON.parse(localStorage.getItem('medicino_admin'));
               if (medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },

         fetchClinic() {
            this.getToken();
            this.$axios
               .get("api/admin/clinics/details?id=" + this.clinicId, {
                  headers: { Authorization: "Bearer " + this.token },
               })
               .then((res) => {
                  if (res.status === 200) {
                     this.clinic = res.data.data.clinic || {};
                  }
               })
               .catch(() => {});
         },

         applyPrescriptionPrintSettings(data) {
            if (!data) {
               return;
            }

            this.print_token_type = data.print_token_type ? Number(data.print_token_type) : 1;
            this.applyPrescriptionPrintConfig(data.prescription_print_config);
         },

         fetchPrescriptionPrintSettings() {
            this.getToken();
            this.loading = true;

            this.$axios
               .get("api/admin/clinics/prescription_print_settings?clinic_id=" + this.clinicId, {
                  headers: { Authorization: "Bearer " + this.token },
               })
               .then((res) => {
                  if (res.data.status) {
                     this.applyPrescriptionPrintSettings(res.data.data);
                  }
               })
               .catch((error) => {
                  if (error.response && error.response.data.message && typeof error.response.data.message !== 'object') {
                     this.$swal("", error.response.data.message, "error");
                  }
               })
               .finally(() => {
                  this.loading = false;
                  this.settingsLoaded = true;
               });
         },

         defaultPrescriptionPrintConfig() {
            return {
               document_title: '',
               header_source: 1,
               custom_clinic_name: '',
               custom_clinic_address: '',
               custom_clinic_phone: '',
               clinic_name_local: '',
               show_doctor_qualification: 1,
               show_doctor_reg_no: 1,
               show_doctor_mobile: 1,
               show_patient_age: 1,
               show_patient_sex: 1,
               show_patient_mobile: 1,
               show_patient_address: 1,
               show_patient_id: 2,
               patient_id_label: 'UHID',
               patient_id_source: 1,
               show_logo: 2,
               show_qr: 1,
               qr_source: 1,
               show_token: 1,
               token_source: 1,
               show_barcode: 1,
               barcode_source: 1,
               vitals: [],
               timing: '',
               disclaimer: '',
               footer_link: '',
               logo: '',
               qr_image: '',
               barcode_image: '',
               logo_url: '',
               qr_image_url: '',
               barcode_image_url: '',
            };
         },

         resolvePrintImageUrl(storedPath, urlFromApi) {
            const apiUrl = String(urlFromApi || '').trim();
            if (apiUrl) {
               return apiUrl;
            }

            const path = String(storedPath || '').trim();
            if (!path) {
               return '';
            }

            if (/^https?:\/\//i.test(path)) {
               return path;
            }

            if (path.indexOf('storage/') === 0) {
               const baseUrl = String(this.$axios.defaults.baseURL || '').replace(/\/+$/, '');
               return baseUrl + '/' + path;
            }

            return this.$image_url + path.replace(/^\/+/, '');
         },

         applyPrescriptionPrintConfig(config) {
            const defaults = this.defaultPrescriptionPrintConfig();
            const merged = Object.assign({}, defaults, config || {});
            ['show_doctor_qualification', 'show_doctor_reg_no', 'show_doctor_mobile', 'show_patient_age', 'show_patient_sex', 'show_patient_mobile', 'show_patient_address', 'show_patient_id', 'show_logo', 'show_qr', 'show_token', 'show_barcode'].forEach((field) => {
               merged[field] = Number(merged[field]) === 2 ? 2 : 1;
            });
            merged.token_source = Number(merged.token_source) === 2 ? 2 : 1;
            merged.barcode_source = Number(merged.barcode_source) === 2 ? 2 : 1;
            merged.qr_source = Number(merged.qr_source) === 2 ? 2 : 1;
            merged.header_source = Number(merged.header_source) === 2 ? 2 : 1;
            merged.patient_id_source = Number(merged.patient_id_source) === 2 ? 2 : 1;
            merged.vitals = Array.isArray(merged.vitals)
               ? merged.vitals.map((v) => String(v || '').trim()).filter(Boolean)
               : [];
            delete merged.show_vitals;
            delete merged.show_patient_name;
            delete merged.barcode_value;
            delete merged.qr_url;
            ['pharmacy_label', 'pharmacy_name', 'pharmacy_address', 'pharmacy_phone', 'pharmacy_note'].forEach((field) => {
               delete merged[field];
            });
            this.prescription_print_config = merged;
            this.logo_file = null;
            this.logo_preview = null;
            this.remove_logo = 0;
            this.qr_image_file = null;
            this.qr_image_preview = null;
            this.remove_qr_image = 0;
            this.barcode_image_file = null;
            this.barcode_image_preview = null;
            this.remove_barcode_image = 0;
         },

         setPrescriptionImage(e, type) {
            const file = e.target.files[0];
            if (!file) {
               return;
            }

            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
               this.$swal("", "Please select a valid image file (JPG, JPEG, PNG)", "error");
               e.target.value = '';
               return;
            }

            if (file.size > 2 * 1024 * 1024) {
               this.$swal("", "Image size should be less than 2MB", "error");
               e.target.value = '';
               return;
            }

            if (type === 'logo') {
               this.logo_file = file;
               this.logo_preview = URL.createObjectURL(file);
               this.remove_logo = 0;
               this.prescription_print_config.show_logo = 1;
            } else if (type === 'barcode') {
               this.barcode_image_file = file;
               this.barcode_image_preview = URL.createObjectURL(file);
               this.remove_barcode_image = 0;
               this.prescription_print_config.show_barcode = 1;
               this.prescription_print_config.barcode_source = 2;
            } else {
               this.qr_image_file = file;
               this.qr_image_preview = URL.createObjectURL(file);
               this.remove_qr_image = 0;
               this.prescription_print_config.show_qr = 1;
               this.prescription_print_config.qr_source = 2;
            }
         },

         removeLogo() {
            this.logo_file = null;
            this.logo_preview = null;
            this.remove_logo = 1;
            this.prescription_print_config.logo = '';
            this.prescription_print_config.logo_url = '';
            if (this.$refs.logoImageInput) {
               this.$refs.logoImageInput.value = '';
            }
         },

         removeQrImage() {
            this.qr_image_file = null;
            this.qr_image_preview = null;
            this.remove_qr_image = 1;
            this.prescription_print_config.qr_image = '';
            this.prescription_print_config.qr_image_url = '';
            if (this.$refs.qrImageInput) {
               this.$refs.qrImageInput.value = '';
            }
         },

         removeBarcodeImage() {
            this.barcode_image_file = null;
            this.barcode_image_preview = null;
            this.remove_barcode_image = 1;
            this.prescription_print_config.barcode_image = '';
            this.prescription_print_config.barcode_image_url = '';
            if (this.$refs.barcodeImageInput) {
               this.$refs.barcodeImageInput.value = '';
            }
         },

         addVital() {
            if (!Array.isArray(this.prescription_print_config.vitals)) {
               this.$set(this.prescription_print_config, 'vitals', []);
            }
            if (this.prescription_print_config.vitals.length >= 10) {
               this.$swal("", "You can add up to 10 vitals only.", "warning");
               return;
            }
            this.prescription_print_config.vitals.push('');
         },

         removeVital(index) {
            this.prescription_print_config.vitals.splice(index, 1);
         },

         appendVitalsToFormData(formData, vitals) {
            const labels = (vitals || [])
               .map((v) => String(v || '').trim())
               .filter(Boolean);

            if (labels.length === 0) {
               formData.append('vitals', '[]');
               return;
            }

            labels.forEach((label) => {
               formData.append('vitals[]', label);
            });
         },

         updatePrescriptionPrintSettings() {
            this.getToken();
            this.errors = {};

            const config = this.prescription_print_config;
            const formData = new FormData();
            formData.append('clinic_id', this.clinicId);
            formData.append('print_token_type', Number(this.print_token_type));
            formData.append('document_title', config.document_title || '');
            formData.append('header_source', Number(config.header_source));
            formData.append('custom_clinic_name', config.custom_clinic_name || '');
            formData.append('custom_clinic_address', config.custom_clinic_address || '');
            formData.append('custom_clinic_phone', config.custom_clinic_phone || '');
            formData.append('clinic_name_local', config.clinic_name_local || '');
            formData.append('show_doctor_qualification', Number(config.show_doctor_qualification));
            formData.append('show_doctor_reg_no', Number(config.show_doctor_reg_no));
            formData.append('show_doctor_mobile', Number(config.show_doctor_mobile));
            formData.append('show_patient_age', Number(config.show_patient_age));
            formData.append('show_patient_sex', Number(config.show_patient_sex));
            formData.append('show_patient_mobile', Number(config.show_patient_mobile));
            formData.append('show_patient_address', Number(config.show_patient_address));
            formData.append('show_patient_id', Number(config.show_patient_id));
            formData.append('patient_id_label', config.patient_id_label || '');
            formData.append('patient_id_source', Number(config.patient_id_source));
            formData.append('show_logo', Number(config.show_logo));
            formData.append('show_qr', Number(config.show_qr));
            formData.append('qr_source', Number(config.qr_source));
            formData.append('show_token', Number(config.show_token));
            formData.append('token_source', Number(config.token_source));
            formData.append('show_barcode', Number(config.show_barcode));
            formData.append('barcode_source', Number(config.barcode_source));
            this.appendVitalsToFormData(formData, config.vitals);
            formData.append('timing', config.timing || '');
            formData.append('disclaimer', config.disclaimer || '');
            formData.append('footer_link', config.footer_link || '');
            formData.append('remove_logo', Number(this.remove_logo));
            formData.append('remove_qr_image', Number(this.remove_qr_image));
            formData.append('remove_barcode_image', Number(this.remove_barcode_image));

            if (this.logo_file) {
               formData.append('logo', this.logo_file);
            }

            if (this.qr_image_file) {
               formData.append('qr_image', this.qr_image_file);
            }

            if (this.barcode_image_file) {
               formData.append('barcode_image', this.barcode_image_file);
            }

            const requestConfig = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            this.loading = true;

            this.$axios
               .post("api/admin/clinics/prescription_print_settings", formData, requestConfig)
               .then((response) => {
                  if (response.data.status) {
                     if (response.data.data) {
                        this.applyPrescriptionPrintSettings(response.data.data);
                     }
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
      },
   };
</script>

<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="row mb-3">
               <div class="col-12">
                  <router-link :to="{ name: 'clinics' }" class="btn btn-primary float-end">
                     <i class='bx bx-chevrons-left'></i> Back
                  </router-link>
               </div>
            </div>

            <div class="row mb-3" v-if="clinic.name">
               <div class="col-12">
                  <b-media class="mb-2">
                     <b-media-body>
                        <h5 class="mt-1 mb-1">{{ clinic.name }}</h5>
                        <p class="text-muted mb-0" v-if="clinic.place">{{ clinic.place }}</p>
                     </b-media-body>
                  </b-media>
               </div>
            </div>

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-3">Print Settings</h4>
                  <p class="text-muted small mb-3">Choose whether the vending machine prints a token only or a full prescription pad, and customize the prescription layout when prescription mode is enabled.</p>

                  <div v-if="loading && !settingsLoaded" class="text-center py-4">
                     <img src="@/assets/images/preloaderspin.gif" alt="Loading" />
                  </div>

                  <b-form v-else @submit.prevent="updatePrescriptionPrintSettings()">
                     <h5 class="mb-3">Print Token Type</h5>
                     <b-row class="align-items-center mb-4">
                        <b-col cols="12" class="form-group mb-0">
                           <b-form-radio-group
                              v-model.number="print_token_type"
                              class="mb-0 print-token-type-group"
                              v-bind:class="{ 'is-invalid': Boolean(errors.print_token_type) }"
                           >
                              <div class="d-flex align-items-center flex-wrap">
                                 <b-form-radio :value="1" name="print_token_type">Token only</b-form-radio>
                                 <b-form-radio :value="2" name="print_token_type" class="ms-4">Prescription</b-form-radio>
                              </div>
                           </b-form-radio-group>
                           <div v-for="(val, index) in errors.print_token_type" :key="index" class="invalid-feedback d-block">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>
                     </b-row>

                     <template v-if="print_token_type === 2">
                        <h4 class="card-title mb-3">Prescription Print Configuration</h4>
                        <p class="text-muted small mb-3">
                           Customize the prescription/token print layout for this clinic. Logo, QR code, token, barcode, and vitals are controlled per clinic below.
                        </p>

                        <h5 class="mb-3">Header</h5>
                        <b-row>
                           <b-col md="8" class="form-group">
                              <label class="control-label d-block mb-2">Clinic Name &amp; Address Source <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model.number="prescription_print_config.header_source"
                                 class="mb-0 header-source-group"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.header_source) }"
                              >
                                 <div class="d-flex align-items-center flex-wrap">
                                    <b-form-radio :value="1" name="header_source">Profile</b-form-radio>
                                    <b-form-radio :value="2" name="header_source" class="ms-4">Custom</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div class="note" v-if="Number(prescription_print_config.header_source) === 1">
                                 Uses clinic name, place, and mobile from the clinic profile.
                              </div>
                              <div class="note" v-else>
                                 Enter a custom clinic name and address for the prescription header.
                              </div>
                              <div v-for="(val, index) in errors.header_source" :key="'header_source-' + index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>

                        <b-row v-if="Number(prescription_print_config.header_source) === 2">
                           <b-col md="4" class="form-group">
                              <label class="control-label">Custom Clinic Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="prescription_print_config.custom_clinic_name" maxlength="120" v-bind:class="{ 'is-invalid': Boolean(errors.custom_clinic_name) }"></b-form-input>
                              <div v-for="(val, index) in errors.custom_clinic_name" :key="'custom_clinic_name-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="4" class="form-group">
                              <label class="control-label">Custom Clinic Address <span class="text-danger">*</span></label>
                              <b-form-input v-model="prescription_print_config.custom_clinic_address" maxlength="255" v-bind:class="{ 'is-invalid': Boolean(errors.custom_clinic_address) }"></b-form-input>
                              <div v-for="(val, index) in errors.custom_clinic_address" :key="'custom_clinic_address-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="4" class="form-group">
                              <label class="control-label">Custom Clinic Phone</label>
                              <b-form-input v-model="prescription_print_config.custom_clinic_phone" maxlength="20" v-bind:class="{ 'is-invalid': Boolean(errors.custom_clinic_phone) }"></b-form-input>
                              <div v-for="(val, index) in errors.custom_clinic_phone" :key="'custom_clinic_phone-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>

                        <b-row>
                           <b-col md="4" class="form-group">
                              <label class="control-label">Timing</label>
                              <b-form-input v-model="prescription_print_config.timing" maxlength="150" placeholder="e.g. Mon-Sat 9:00 AM - 6:00 PM" v-bind:class="{ 'is-invalid': Boolean(errors.timing) }"></b-form-input>
                              <div v-for="(val, index) in errors.timing" :key="'timing-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>

                        <h5 class="mb-3 mt-2">Display Options</h5>
                        <b-row>
                           <b-col md="3" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_logo" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Logo</span>
                              </b-form-checkbox>
                           </b-col>
                           <b-col md="3" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_token" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Token Number</span>
                              </b-form-checkbox>
                           </b-col>
                           <b-col md="3" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_barcode" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Barcode</span>
                              </b-form-checkbox>
                           </b-col>
                           <b-col md="3" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_qr" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show QR Code</span>
                              </b-form-checkbox>
                           </b-col>
                        </b-row>

                        <h5 class="mb-3 mt-2">Doctor Details</h5>
                        <p class="text-muted small mb-3">Doctor name always prints. Choose which additional doctor details appear on the prescription.</p>
                        <b-row>
                           <b-col md="4" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_doctor_qualification" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Qualification</span>
                              </b-form-checkbox>
                           </b-col>
                           <b-col md="4" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_doctor_reg_no" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Reg. No.</span>
                              </b-form-checkbox>
                           </b-col>
                           <b-col md="4" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_doctor_mobile" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Mobile</span>
                              </b-form-checkbox>
                           </b-col>
                        </b-row>

                        <h5 class="mb-3 mt-2">Patient Details</h5>
                        <p class="text-muted small mb-3">Patient name always prints. Choose which other patient fields appear on the prescription.</p>
                        <b-row>
                           <b-col md="4" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_patient_age" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Age</span>
                              </b-form-checkbox>
                           </b-col>
                           <b-col md="4" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_patient_sex" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Sex</span>
                              </b-form-checkbox>
                           </b-col>
                           <b-col md="4" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_patient_mobile" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Mobile</span>
                              </b-form-checkbox>
                           </b-col>
                        </b-row>
                        <b-row>
                           <b-col md="4" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_patient_address" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Address</span>
                              </b-form-checkbox>
                           </b-col>
                           <b-col md="4" class="form-group">
                              <b-form-checkbox v-model="prescription_print_config.show_patient_id" :value="1" :unchecked-value="2">
                                 <span class="ms-2">Show Patient ID (UHID)</span>
                              </b-form-checkbox>
                           </b-col>
                        </b-row>

                        <template v-if="Number(prescription_print_config.show_patient_id) === 1">
                           <b-row>
                              <b-col md="4" class="form-group">
                                 <label class="control-label">Patient ID Label <span class="text-danger">*</span></label>
                                 <b-form-input
                                    v-model="prescription_print_config.patient_id_label"
                                    maxlength="30"
                                    placeholder="e.g. UHID, MRN, Patient ID"
                                    v-bind:class="{ 'is-invalid': Boolean(errors.patient_id_label) }"
                                 ></b-form-input>
                                 <div class="note">Label shown before the patient ID on the prescription.</div>
                                 <div v-for="(val, index) in errors.patient_id_label" :key="'patient_id_label-' + index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>
                              <b-col md="8" class="form-group">
                                 <label class="control-label d-block mb-2">Patient ID Source <span class="text-danger">*</span></label>
                                 <b-form-radio-group
                                    v-model.number="prescription_print_config.patient_id_source"
                                    class="mb-0 patient-id-source-group"
                                    v-bind:class="{ 'is-invalid': Boolean(errors.patient_id_source) }"
                                 >
                                    <div class="d-flex align-items-center flex-wrap">
                                       <b-form-radio :value="1" name="patient_id_source">Medicino ID</b-form-radio>
                                       <b-form-radio :value="2" name="patient_id_source" class="ms-4">Clinic patient ID (entered at consultation)</b-form-radio>
                                    </div>
                                 </b-form-radio-group>
                                 <div class="note" v-if="Number(prescription_print_config.patient_id_source) === 1">
                                    Prints Medicino patient ID (e.g. UHID: MEDP-12345).
                                 </div>
                                 <div class="note" v-else>
                                    Prints the clinic patient ID saved when adding a consultation.
                                 </div>
                                 <div v-for="(val, index) in errors.patient_id_source" :key="'patient_id_source-' + index" class="invalid-feedback d-block">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>
                           </b-row>
                        </template>

                        <h5 class="mb-3 mt-2">Logo</h5>
                        <b-row>
                           <b-col md="6" class="form-group">
                              <label class="control-label">Print Logo <span class="note">[Allowed: jpg, jpeg, png | Max: 2MB]</span></label>
                              <img
                                 v-if="hasCurrentLogo"
                                 :src="currentLogoSrc"
                                 class="print-image-preview mb-2 d-block"
                                 alt="Current print logo"
                              />
                              <input
                                 ref="logoImageInput"
                                 type="file"
                                 accept="image/png,image/jpeg,image/jpg"
                                 class="form-control"
                                 @change="setPrescriptionImage($event, 'logo')"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.logo) }"
                              />
                              <div class="note">Upload a logo used on prescription/token prints for this clinic.</div>
                              <b-button
                                 v-if="hasCurrentLogo"
                                 type="button"
                                 variant="outline-danger"
                                 size="sm"
                                 class="mt-2"
                                 @click="removeLogo()"
                              >
                                 Remove Logo
                              </b-button>
                              <div v-for="(val, index) in errors.logo" :key="'logo-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>

                        <template v-if="Number(prescription_print_config.show_token) === 1">
                           <h5 class="mb-3 mt-2">Token</h5>
                           <b-row>
                              <b-col md="6" class="form-group">
                                 <label class="control-label d-block mb-2">Token Source <span class="text-danger">*</span></label>
                                 <b-form-radio-group
                                    v-model.number="prescription_print_config.token_source"
                                    class="mb-0 token-source-group"
                                    v-bind:class="{ 'is-invalid': Boolean(errors.token_source) }"
                                 >
                                    <div class="d-flex align-items-center flex-wrap">
                                       <b-form-radio :value="1" name="token_source">Medicino Token</b-form-radio>
                                       <b-form-radio :value="2" name="token_source" class="ms-4">Clinic Token</b-form-radio>
                                    </div>
                                 </b-form-radio-group>
                                 <div class="note">Choose whether the printed token number is from Medicino or the clinic.</div>
                                 <div v-for="(val, index) in errors.token_source" :key="'token_source-' + index" class="invalid-feedback d-block">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-col>
                           </b-row>
                        </template>

                        <template v-if="Number(prescription_print_config.show_barcode) === 1">
                        <h5 class="mb-3 mt-2">Barcode</h5>
                        <b-row>
                           <b-col md="6" class="form-group">
                              <label class="control-label d-block mb-2">Barcode Source <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model.number="prescription_print_config.barcode_source"
                                 class="mb-0 barcode-source-group"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.barcode_source) }"
                              >
                                 <div class="d-flex align-items-center flex-wrap">
                                    <b-form-radio :value="1" name="barcode_source">Auto Generate</b-form-radio>
                                    <b-form-radio :value="2" name="barcode_source" class="ms-4">Custom Image</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div class="note">Auto generate creates a barcode from the booking ID. Custom image uses your uploaded barcode image.</div>
                              <div v-for="(val, index) in errors.barcode_source" :key="'barcode_source-' + index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                        <b-row v-if="Number(prescription_print_config.barcode_source) === 2">
                           <b-col md="6" class="form-group">
                              <label class="control-label">Barcode Image <span class="note">[Allowed: jpg, jpeg, png | Max: 2MB]</span> <span class="text-danger">*</span></label>
                              <img
                                 v-if="hasCurrentBarcodeImage"
                                 :src="currentBarcodeSrc"
                                 class="print-image-preview mb-2 d-block"
                                 alt="Current barcode"
                              />
                              <input
                                 ref="barcodeImageInput"
                                 type="file"
                                 accept="image/png,image/jpeg,image/jpg"
                                 class="form-control"
                                 @change="setPrescriptionImage($event, 'barcode')"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.barcode_image) }"
                              />
                              <div class="note">Upload a custom barcode image for prescription prints.</div>
                              <b-button
                                 v-if="hasCurrentBarcodeImage"
                                 type="button"
                                 variant="outline-danger"
                                 size="sm"
                                 class="mt-2"
                                 @click="removeBarcodeImage()"
                              >
                                 Remove Barcode Image
                              </b-button>
                              <div v-for="(val, index) in errors.barcode_image" :key="'barcode_image-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                        </template>

                        <h5 class="mb-3 mt-2">Vitals</h5>
                        <p class="text-muted small mb-3">Add vital labels for the prescription sidebar (e.g. B.P., Wt.). Leave empty to hide the vitals column on print.</p>
                        <div class="form-control border-0 px-0" v-bind:class="{ 'is-invalid': Boolean(errors.vitals) }">
                           <b-row
                              v-for="(vital, index) in prescription_print_config.vitals"
                              :key="'vital-' + index"
                              class="mb-2 align-items-center"
                           >
                              <b-col md="4">
                                 <b-form-input
                                    v-model="prescription_print_config.vitals[index]"
                                    maxlength="30"
                                    placeholder="e.g. B.P."
                                    v-bind:class="{ 'is-invalid': Boolean(errors['vitals.' + index]) }"
                                 ></b-form-input>
                              </b-col>
                              <b-col md="2" class="d-flex align-items-center">
                                 <i class="fas fa-minus-circle text-danger me-2" role="button" @click="removeVital(index)"></i>
                                 <i
                                    v-if="index === prescription_print_config.vitals.length - 1 && prescription_print_config.vitals.length < 10"
                                    class="fas fa-plus-circle text-success"
                                    role="button"
                                    @click="addVital()"
                                 ></i>
                              </b-col>
                           </b-row>
                        </div>
                        <b-button
                           v-if="!prescription_print_config.vitals.length"
                           type="button"
                           variant="outline-primary"
                           size="sm"
                           class="mb-3"
                           @click="addVital()"
                        >
                           Add Vital
                        </b-button>
                        <div class="note mb-3">Maximum 10 vitals, 30 characters each.</div>

                        <template v-if="Number(prescription_print_config.show_qr) === 1">
                        <h5 class="mb-3 mt-2">QR Code</h5>
                        <b-row>
                           <b-col md="6" class="form-group">
                              <label class="control-label d-block mb-2">QR Source <span class="text-danger">*</span></label>
                              <b-form-radio-group
                                 v-model.number="prescription_print_config.qr_source"
                                 class="mb-0 qr-source-group"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.qr_source) }"
                              >
                                 <div class="d-flex align-items-center flex-wrap">
                                    <b-form-radio :value="1" name="qr_source">Auto Generate</b-form-radio>
                                    <b-form-radio :value="2" name="qr_source" class="ms-4">Custom Image</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div class="note">Auto generate builds a QR from patient details. Custom image uses your uploaded QR image.</div>
                              <div v-for="(val, index) in errors.qr_source" :key="'qr_source-' + index" class="invalid-feedback d-block">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                        <b-row v-if="Number(prescription_print_config.qr_source) === 2">
                           <b-col md="6" class="form-group">
                              <label class="control-label">QR Image <span class="note">[Allowed: jpg, jpeg, png | Max: 2MB]</span> <span class="text-danger">*</span></label>
                              <img
                                 v-if="hasCurrentQrImage"
                                 :src="currentQrSrc"
                                 class="print-image-preview mb-2 d-block"
                                 alt="Current QR"
                              />
                              <input
                                 ref="qrImageInput"
                                 type="file"
                                 accept="image/png,image/jpeg,image/jpg"
                                 class="form-control"
                                 @change="setPrescriptionImage($event, 'qr')"
                                 v-bind:class="{ 'is-invalid': Boolean(errors.qr_image) }"
                              />
                              <div class="note">Upload a custom QR image for prescription prints.</div>
                              <b-button
                                 v-if="hasCurrentQrImage"
                                 type="button"
                                 variant="outline-danger"
                                 size="sm"
                                 class="mt-2"
                                 @click="removeQrImage()"
                              >
                                 Remove QR Image
                              </b-button>
                              <div v-for="(val, index) in errors.qr_image" :key="'qr_image-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                        </template>

                        <h5 class="mb-3 mt-2">Footer</h5>
                        <b-row>
                           <b-col md="6" class="form-group">
                              <label class="control-label">Disclaimer</label>
                              <b-form-textarea v-model="prescription_print_config.disclaimer" rows="3" maxlength="500" v-bind:class="{ 'is-invalid': Boolean(errors.disclaimer) }"></b-form-textarea>
                              <div v-for="(val, index) in errors.disclaimer" :key="'disclaimer-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="6" class="form-group">
                              <label class="control-label">Footer Link / Text</label>
                              <b-form-textarea v-model="prescription_print_config.footer_link" rows="3" maxlength="255" v-bind:class="{ 'is-invalid': Boolean(errors.footer_link) }"></b-form-textarea>
                              <div v-for="(val, index) in errors.footer_link" :key="'footer_link-' + index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </b-row>
                     </template>

                     <b-row>
                        <b-col md="12" class="form-group d-flex align-items-end">
                           <b-button type="submit" class="mr-3 submit-button" variant="primary" :disabled="loading">
                              Update Print Settings
                           </b-button>
                        </b-col>
                     </b-row>
                  </b-form>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>

<style scoped>
.print-image-preview {
   width: 120px;
   height: 120px;
   object-fit: contain;
   border-radius: 8px;
   border: 2px solid #e9ecef;
   background: #fff;
   padding: 6px;
}

.note {
   font-size: 12px;
   color: #6c757d;
   font-style: italic;
}

.print-token-type-group >>> .custom-control,
.print-token-type-group >>> .form-check,
.token-source-group >>> .custom-control,
.token-source-group >>> .form-check,
.header-source-group >>> .custom-control,
.header-source-group >>> .form-check,
.patient-id-source-group >>> .custom-control,
.patient-id-source-group >>> .form-check,
.barcode-source-group >>> .custom-control,
.barcode-source-group >>> .form-check,
.qr-source-group >>> .custom-control,
.qr-source-group >>> .form-check {
   display: inline-flex;
   margin-right: 0;
   padding-left: 1.5rem;
}
</style>
